import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nft-card-back-pay" }
const _hoisted_2 = { class: "text-area" }
const _hoisted_3 = { class: "date-row" }
const _hoisted_4 = { class: "sub-text" }
const _hoisted_5 = { class: "main-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-line" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('nftCard.monthUse', [_ctx.month])), 1),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.info.monthPrice) + " " + _toDisplayString(_ctx.$t(_ctx.unit)), 1)
    ])
  ]))
}